<template>
  <v-footer padless class="z-10" color="footer" dark>
    <v-col class="text-center" cols="12">
      {{ new Date().getFullYear() }} — <strong>Living Evidence to Inform Health Decisions</strong>
    </v-col>
  </v-footer>
</template>

<script>
export default {
  methods: {
    // CODE FOR MAKE NOTIFICATION
    // handleNotify() {
    //   Notification.requestPermission().then((e) => {
    //     const notification = new Notification("test", {
    //       body: "This is a test notification",
    //     });
    //     console.log(notification);
    //   });
    // },
  },
};
</script>

<style>
</style>